import {camelizeKeys, decamelizeKeys} from 'humps';
import ReactOnRails from "react-on-rails";

export default {
  webLogin(email, password) {
    // Since we are making a request to a non-API JSON action, we need a CSRF token.
    const authenticityToken = ReactOnRails.authenticityToken();

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/users/log_in_only",
        type: "POST",
        data: decamelizeKeys({ email, password, authenticityToken }),
        success: response => resolve(response),
        error: response => reject(response.responseText)
      });
    });
  },

  /**
   * Create a user.
   * @param {Object} userParams - An object that includes fields to populate for the user.
   * @param {?String} licenseKeyText - The license key text representing the license key to which the user should be linked.
   * @param {String} portal - The portal from which the user is creating an account.
   * @returns {Promise<?Object>} - When successful, returns an object of the user's data. When unsuccessful, the promise will reject with an error message string.
   */
  createUser(userParams, licenseKeyText, portal) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/users",
        type: "POST",
        headers: { APP_TYPE: portal },
        data: decamelizeKeys({ user: userParams, licenseKeyText }),
        success: response => resolve(camelizeKeys(response)),
        error: response => {
          // Simple error messages will be returned as the response text.
          let errorMessage = response.responseText;
          // Complex error messages will be returned as a summary field.
          if (response.responseJSON && response.responseJSON.summary && response.responseJSON.summary.length > 0) {
            errorMessage = response.responseJSON.summary[0];
          }
          else if (response.responseJSON && response.responseJSON.message)
            errorMessage = response.responseJSON.message;

          reject(errorMessage);
        }
      });
    });
  },

  /**
   * This endpoint will validate whether the given user parameters will successfully create an account or not, without actually creating the account.
   * @param {Object} userParams - An object that includes the user parameters (first name, last name, email, etc).
   * @param {Boolean} deferredUserCreate - If true, this means the user will be creating an account later, and will not be providing a password right now.
   * @param {string} purchaseFlow - The purchase flow from which the API is being invoked.
   * @returns {Promise<?Object>} - When successful, the user parameters are valid for account creation. When unsuccessful, the response text will indicate the reason the parameters are invalid (ex. password is too short).
   */
  validateNewParams(userParams, deferredUserCreate, purchaseFlow) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/users/validate_new_params",
        type: "POST",
        data: decamelizeKeys({ user: userParams, deferredUserCreate, purchaseFlow }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  },

  validateEmail(email) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/users/validate_email",
        type: "POST",
        data: decamelizeKeys({ email }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  }
};
